export const GET_INDUSTRIES = 'GET_INDUSTRIES';
export const SET_INDUSTRIES = 'SET_INDUSTRIES';
